import { render, staticRenderFns } from "./ShareEntityDialog.vue?vue&type=template&id=b4335e0a&scoped=true"
import script from "./ShareEntityDialog.vue?vue&type=script&lang=js"
export * from "./ShareEntityDialog.vue?vue&type=script&lang=js"
import style0 from "./ShareEntityDialog.vue?vue&type=style&index=0&id=b4335e0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4335e0a",
  null
  
)

export default component.exports